// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1EYow","label":"styles_label__2iIhR"};